import { Injectable } from "@angular/core";
import * as _ from "lodash";
import { IAccount, IFlatAccount } from "../models/account.model";

@Injectable({
    providedIn: "root",
})
export class AccountFlatteningService {

    constructor() { }

    flattenAccounts(accounts: IAccount[], level: number = 0): IFlatAccount[] {
        let flatList: IFlatAccount[] = [];
        if(accounts && accounts?.length > 0) {
            for (const account of accounts) {
                const flatAccount: IFlatAccount = {
                    ...account,
                    level: level
                };
                flatList.push(flatAccount);
                if (account.childAccounts && account.childAccounts.length > 0) {
                    flatList = flatList.concat(this.flattenAccounts(account.childAccounts, level + 1));
                }
            }
        }
        return flatList;
    }

}